/* tslint:disable */
/* eslint-disable */
export enum TargetFailOption {
  MarkAsFailed = 1
}
